import React, { useEffect, useState } from 'react'
import { Checkbox } from '@arnsbogroup/react-voicearchive'

const SyntheticVoice = ({
  admin = false,
  match: { params: { supplierId } },
}) => {

  const [isLoading, setLoading] = useState(false);
  const [loadStatus, setLoadStatus] = useState(null);
  const [voiceList, setVoiceList] = useState([]);
  const [demoList, setDemoList] = useState([]);
  const [sampleList, setSampleList] = useState([]);
  const [supplier, setSupplier] = useState(null);
  
  useEffect(() => {
    setLoading(true);
    fetch(`/rest/v2/supplier/${supplierId}`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((supplier) => {
        setSupplier(supplier);
      });
    fetch(`/rest/v2/supplier/${supplierId}/demos`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((demos) => {
        setDemoList(demos.data);
      });
    fetch(`/rest/v2/supplier/${supplierId}/synthetic-voice`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((syntheticVoiceList) => {
        setVoiceList(syntheticVoiceList.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const loadSampleList = () => {
    fetch(`/rest/v2/supplier/${supplierId}/synthetic-voice-demos`, { credentials: 'same-origin' })
    .then((response) => response.json())
    .then((syntheticVoiceDemoList) => {
      setSampleList(syntheticVoiceDemoList.data);
    });
  }

  useEffect(() => {
    loadSampleList();
  }, [voiceList]);

  const handleFileUpload = (event) => {
    setLoading(true);
    const files = event.target.files;
    const data = new FormData();
    for (let i = 0; i < files.length; i++) {
      data.append("files[]", files[i]);
    }

    fetch(`/rest/v2/supplier/${supplierId}/synthetic-voice`, {
      credentials: 'same-origin',
      method: 'POST',
      body: data,
    })
      .then((response) => response.json())
      .then((syntheticVoiceList) => {
        if (syntheticVoiceList.success === true) {
          setVoiceList(syntheticVoiceList.data);
        } else {
          if (syntheticVoiceList.errors && syntheticVoiceList.errors.length > 0) {
            toastr.error(syntheticVoiceList.errors[0]);
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSampleUpdate = (event) => {
    setLoading(true);
    const files = event.target.files;
    const data = new FormData();
    for (let i = 0; i < files.length; i++) {
      data.append("files[]", files[i]);
    }

    fetch(`/rest/v2/supplier/${supplierId}/synthetic-voice-demos`, {
      credentials: 'same-origin',
      method: 'POST',
      body: data,
    })
      .then((response) => response.json())
      .then(() => {
        loadSampleList();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleIsVoicefinderActiveChange = (event) => {
    setLoading(true);
    fetch(`/rest/v2/supplier/${supplierId}/synthetic-voice`, {
      credentials: 'same-origin',
      method: 'PUT',
      body: JSON.stringify({
        uid: voiceList[0].uid,
        is_active_on_voicefinder: event.target.checked
      }),
    })
      .then((response) => response.json())
      .then((syntheticVoiceList) => {
        setVoiceList(syntheticVoiceList.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClipCompare = (audioUrl) => {
    setLoading(true);

    if (voiceList[0].supplier_demo_url === audioUrl) {

      fetch(`/rest/v2/supplier/${supplierId}/synthetic-voice`, {
        credentials: 'same-origin',
        method: 'PUT',
        body: JSON.stringify({
          uid: voiceList[0].uid,
          supplier_demo_url: '',
          synthetic_demo_url: '',
        }),
      })
        .then((response) => response.json())
        .then((syntheticVoiceList) => {
          setVoiceList(syntheticVoiceList.data);
        })
        .finally(() => {
          setLoading(false);
        });

    } else {

      setLoadStatus('Converting speech to text...');

      fetch(`/rest/v2/openai/speech-to-text`, {
        credentials: 'same-origin',
        method: 'POST',
        body: JSON.stringify({
          audio_url: audioUrl
        }),
      })
        .then((response) => response.json())
        .then((speechToText) => {

          setLoadStatus('Converting text to speech...');
          fetch(`/rest/v2/syntheticvoice/script-to-voice`, {
            credentials: 'same-origin',
            method: 'POST',
            body: JSON.stringify({
              voiceId: voiceList[0].elevenlabs_voice_id,
              text: speechToText.data.text,
            }),
          })
            .then((response) => response.json())
            .then((audioClip) => {
              
              setLoadStatus('Saving...');
              fetch(`/rest/v2/supplier/${supplierId}/synthetic-voice`, {
                credentials: 'same-origin',
                method: 'PUT',
                body: JSON.stringify({
                  uid: voiceList[0].uid,
                  supplier_demo_url: audioUrl,
                  synthetic_demo_url: audioClip.data.url,
                }),
              })
                .then((response) => response.json())
                .then((syntheticVoiceList) => {
                  setVoiceList(syntheticVoiceList.data);
                })
                .finally(() => {
                  setLoading(false);
                  setLoadStatus(null);
                });

            });

        });

    }
  };

  const deleteSample = (sampleId) => {
    setLoading(true);

    fetch(`/rest/v2/supplier/${supplierId}/synthetic-voice-demos`, {
      credentials: 'same-origin',
      method: 'DELETE',
      body: JSON.stringify({
        sample_id: sampleId,
      }),
    })
      .finally(() => {
        setLoading(false);
        loadSampleList();
      });
  }

  const NoSyntheticVoice = () => {
    return <div>
      <div class="text-md font-bold">No synthetic voice found</div>

      <div class="mt-4">
        <label class="text-gray-700">Upload clean audio (max 10mb)</label>
      </div>
      <input type="file" multiple onChange={handleFileUpload} />
    </div>
  };

  return (
    <div className="w-full p-8">

      {isLoading && <div>Loading...</div>}
      
      {loadStatus && <div className='my-4 font-bold'>{loadStatus}</div>}

      {!isLoading && voiceList.length === 0 && <NoSyntheticVoice />}

      {!isLoading && voiceList.length > 0 && (
        <div className='grid grid-cols-2'>

          {(supplier && supplier.userid) && (
            <div>

              <div class="my-2">
                <Checkbox
                    label="Is active on Voicefinder"
                    checked={voiceList[0].is_active_on_voicefinder === "1"}
                    onChange={handleIsVoicefinderActiveChange}
                />
              </div>

              {(voiceList[0].is_active_on_voicefinder === "1") && (
                <a href={`https://www.voicearchive.com/en/voicefinder/ai/${supplier.userid}`} target='_blank'>Voicefinder link to {supplier.userid} synthetic voices</a>
              )}

              {(demoList && demoList.length > 0) && (
                <div>
                  <div class="mt-8 mb-2">
                    <label className="text-gray-700 font-bold">Demos to compare</label>
                    <p>Generate a synthetic audio clip to compare with.</p>
                  </div>
                  <div>
                    {demoList.map((demo) => (
                      <div key={demo.id}>
                        <Checkbox
                            label={demo.name || 'No name'}
                            checked={voiceList[0].supplier_demo_url === demo.cdn_url}
                            onChange={() => handleClipCompare(demo.cdn_url)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          <div>
            <div className='my-4 font-bold'>Audio clips used for model training</div>

            {sampleList.map((sample) => (
              <div>
                <span>{sample.file_name}</span>
                <span className='ml-4 cursor-pointer' onClick={() => deleteSample(sample.sample_id)}>Delete</span>
              </div>
            ))}
            
            <div class="mt-4">
              <label class="text-gray-700">Upload clean audio (max 10mb)</label>
            </div>
            <input type="file" multiple onChange={handleSampleUpdate} />
          </div>

        </div>
      )}
      
    </div>
  )
}

export default SyntheticVoice
